import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
export default function ExpStatus(param) {
    var statusID = param.statusID, statusName = param.statusName;
    var _useState = _sliced_to_array(useState({
        color: "#FF731D",
        bg: "rgba(255, 115, 29, 0.15)",
        statusName: ""
    }), 2), statusObj = _useState[0], setStatusObj = _useState[1];
    useEffect(function() {
        switch(statusID){
            case 2:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#FF731D",
                        bg: "rgba(255, 115, 29, 0.15)",
                        statusName: statusName
                    });
                });
                break;
            case 3:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(114, 225, 40, 0.87)",
                        bg: "rgba(238, 251, 229, 1)",
                        statusName: statusName
                    });
                });
                break;
            case "overdue":
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(249, 80, 87, 1)",
                        bg: "rgba(255, 0, 0, 0.15)",
                        statusName: statusName
                    });
                });
                break;
            case 1:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#747474",
                        bg: "#F4F4F4",
                        statusName: statusName
                    });
                });
                break;
            default:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(249, 80, 87, 1)",
                        bg: "rgba(255, 0, 0, 0.15)",
                        statusName: statusName
                    });
                });
                break;
        }
    }, [
        statusID
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-auto",
        children: /*#__PURE__*/ _jsx("div", {
            className: "px-3 py-1 mx-auto",
            style: {
                color: statusObj.color,
                backgroundColor: statusObj.bg,
                borderRadius: "20px"
            },
            children: statusObj.statusName
        })
    });
}
